export function parseUserListResponse(result) {
  if (Array.isArray(result)) {
    return {
      usuarios: result,
      estatisticas: null,
      totalRegistros: result.length,
      pagina: 0,
      pageSize: result.length,
      totalDePaginas: 1,
    };
  }

  return {
    usuarios: result?.Usuarios ?? result?.ListUsuarios ?? [],
    estatisticas: result?.Estatisticas ?? null,
    totalRegistros: result?.TotalRegistros ?? result?.Usuarios?.length ?? result?.ListUsuarios?.length ?? 0,
    pagina: result?.Pagina ?? 0,
    pageSize: result?.PageSize ?? result?.Usuarios?.length ?? result?.ListUsuarios?.length ?? 25,
    totalDePaginas: result?.TotalDePaginas ?? 1,
  };
}
